export default "__VITE_ASSET__BWC2fkeu__"